import { useData } from "vike-react/useData";
import type { Data } from "./+data";
import Store from "@/pages/Store";

export default function Page() {
  const { store, reviews } = useData<Data>();
  // Keyed by store so store -> store navigation (similar stores rail) remounts with fresh
  // state instead of carrying over the previous store's rail scroll, dialogs and edits.
  return <Store key={store._id} initialStore={store} initialReviewsData={reviews} />;
}
